import React from 'react'
import classNames from 'classnames'

import { Icon } from '@app/components/util'
import { LntButton } from '@app/components/base'

import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { TopFiltersProps } from './types'

export const TopFilters: React.FC<TopFiltersProps> = ({
  children,
  className: outerClassName,
  canReset,
  onSearch,
  onClear
}) => {
  const className = classNames(styles.topFilters, outerClassName)

  return (
    <div className={ className }>
      <div className={ styles.topFilters__selects }>{ children }</div>

      <div className={ styles.topFilters__buttons }>
        <LntButton
          htmlType='reset'
          disabled={ !canReset }
          type={ BUTTON_TYPE.textDanger }
          size={ SIZE.middle }
          onClick={ onClear }
          icon={ <Icon name={ ICON_NAME.resetSearch } /> }
        >
          Сбросить
        </LntButton>

        <LntButton
          htmlType='submit'
          type={ BUTTON_TYPE.primary }
          size={ SIZE.middle }
          onClick={ onSearch }
        >
          Найти
        </LntButton>
      </div>
    </div>
  )
}
